import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TypeArticle } from 'src/api/models';

@Component({
  selector: 'app-article-type-select',
  templateUrl: './article-type-select.component.html',
  styleUrls: ['./article-type-select.component.css']
})
export class ArticleTypeSelectComponent implements OnInit {

  @Input('id') public id: number;
  @Output() idChange = new EventEmitter<number>();

  @Input('width') width: number;
  @Input() readOnly: boolean = false;

  @Input() cell: any;

  articlesTypes = [];

  constructor(private translateService: TranslateService) { 
    for (var t in TypeArticle) {
      let value = parseInt(t, 10);
      var isValueProperty = (value >= 0);
      if (isValueProperty) {
        this.articlesTypes.push({ id: value, name: this.translateService.instant('Stock.Articles.Types.' + TypeArticle[t])});
      }
    }    
  }

  ngOnInit(): void {
    // this.id = 0;
  }

  valueChanged(e) {
    if (!!this.cell) {
      this.cell.setValue(this.id);
    }    

    this.idChange.emit(this.id);
  }   
}
